import { useState } from "react";
import axios from "axios";

type Props = {
  token: string | null | undefined;
  userId: string | undefined;
  deviceId: string | undefined;
  callback?: Function;
};


const useCancelShareDevice = ({ token, userId, deviceId, callback }: Props) => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");
  const [loading, setloading] = useState(false);

  const baseUrl = process.env.REACT_APP_API_URL;

  const fetch = () => {
    setloading(true);
    axios({
      method: "post",
      url: `${baseUrl}/api/devices/${userId}/${deviceId}/share/cancel`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        setResponse(res.data);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setloading(false);
        if(callback) callback();
      });
  };

  // custom hook returns value
  return { response, error, loading, fetch };
};

export default useCancelShareDevice;
